import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {GetFromLocalStorage} from "../../Utility/Utility";
import {DynamicDashboardComponent} from "../../../app/shared/dynamic-dashboard/dynamic-dashboard.component";
import { idsToBase64 } from "../Marketplace/ProductUtility";

function getStatoVenditoreLabel(profilo: any): string {

  const stato = Number(profilo?.stato);

  switch (stato) {

    case 89:
      return 'Acquirente';

    case 90:
      return 'Richiesta venditore in verifica';

    case 91:
      return 'Venditore abilitato';

    case 92:
      return 'Venditore sospeso';

    default:
      return profilo?.statoObject?.label || '-';

  }

}

function KpiList(): {nome: string, param: string, customClass?:string}[]{
  return [
    {
      nome: "Articoli in vendita",
      param: "prodottiVendita",
      customClass: ""
    },
    {
      nome: "Articoli venduti",
      param: "prodottiVenduti",
      customClass: "color-positive"
    },
    {
      nome:'Totale venduto',
      param: 'totaleVendita',
      customClass: "color-positive"
    },
    // {
    //   nome:'Ordini evasi',
    //   param: 'ordiniEvasi',
    //   customClass: "color-teal"
    // }
  ]
}

function Dashboard() {
  var OBJ: OggettoConfig = {
    Id: "dvendite",
    MenuItems: [
      {
        path: 'shared/dynamicedit/dvendite',
        title: "Panoramica vendite",
        icon: "fas fa-cart",
        class: "",
        capacita: ['is-venditore'],
      }
    ],
    DisableEdit:true,
    RestRoute: '/progetti/dashboard',
    HasGet:false,
    asyncMap:(x:any, component:DynamicEditComponent, callback: (x)=>void)=>{
      const user = GetFromLocalStorage('currentUser');
      component.api.ClassicPost(
        "/progetti/progetti/dashboard/negozio",
        {
          anno: 2026,
          mese: 3
        }
      ).subscribe((dashboardRes: any) => {

        component.api.ClassicPost(
          "/anagrafica/profilo/cliente",
          {
            ...user,
            id: user.negozioId ?? user.id
          }
        ).subscribe(async (profiloRes: any) => {

          let fotoProfilo = null;

          if (profiloRes?.id_immagine) {

            const immagini = await idsToBase64(
              [profiloRes.id_immagine],
              component.api.getBaseAPI()
            );

            fotoProfilo = immagini?.[0] || null;

          }

          callback({
            ...dashboardRes,
            profiloNegozio: profiloRes,
            fotoProfiloNegozio: fotoProfilo
          });

        });

      });

    },
    campi:[
      CampoAggiuntivo.Html("",(x,)=>{
        return `
    <div class="acc-hero" style="margin-bottom:18px;">
      <div class="acc-avatar">
        ${
          x.fotoProfiloNegozio
            ? `<img class="acc-avatar-img" src="${x.fotoProfiloNegozio}">`
            : `🏪`
        }
      </div>

      <div class="acc-info">
        <div class="acc-name">${x.profiloNegozio?.nominativo || GetFromLocalStorage('currentUser')?.nominativo}</div>
        <div class="acc-meta">
          📍 ${x.profiloNegozio?.citta || GetFromLocalStorage('currentUser')?.citta || ''}
          · Membro dal ${x.profiloNegozio?.createdAt ? new Date(x.profiloNegozio.createdAt).getFullYear() : ''}
        </div>
        <div class="acc-badges">
          <span class="acc-bdg teal">✓ Venditore verificato</span>
        </div>
      </div>

<!--      <div class="acc-saldo-box">-->
<!--        <div class="acc-saldo-lbl">Saldo disponibile</div>-->
<!--        <div class="acc-saldo-val">€2.847,50</div>-->
<!--        <div class="acc-saldo-sub">+€345,00 questo mese</div>-->
<!--        <button class="btn-t" style="margin-top:10px;width:100%;font-size:13px;" onclick="showToast('💸 Richiesta prelievo inviata!')">Preleva fondi</button>-->
<!--      </div>-->
    </div>
  `
      },()=>true, {class:"col-lg-12"}),
      ...KpiList().map(x=>CampoAggiuntivo.Html("", (oggetto)=>{
        return `
        <div class="acc-kpi-card">
          <div class="acc-kpi-val">${ oggetto[x.param] ?? 'N/A'}</div>
          <div class="acc-kpi-lbl ${x.customClass ?? ''}">${x.nome}</div>
        </div>
       `
      }, ()=>true, {class:"col-lg-6"})),
      CampoAggiuntivo.ComponentField("",DynamicDashboardComponent, ()=>{return {}}, ()=>true),
      //Grafico,
      CampoAggiuntivo.Html("",(x)=>{
        return `
        <div class="card no-shadow no-transform"><div class="cb2">
        <div class="ch"><div class="ct">Statistiche ordini</div><select class="sel-sm"><option>Tutto</option></select></div>
        <div class="dashboard-gridmp">
          <div class="item"><div class="value color-teal"  style="var(--teal)">${x.ordiniTotali}</div><div class="title">Totali</div></div>
          <div  class="item" ><div class="value color-positive">${x.ordiniEvasi}</div><div class="title">Consegnati</div></div>
          <div class="item" ><div class="value color-yellow">${x.ordiniAttesa}</div><div class="title">In attesa</div></div>
          <div class="item" ><div class="value color-red">${x.ordiniAnnullati}</div><div class="title">Annullati</div></div>
        </div>
      </div></div>`

      }, ()=>true, {class:'col-lg-12 mt-3'})


    ],
  }
  return OBJ;
}


export var DashboardEnv = () => {
  var env: any = {
    Modules: {
      "Dashboard": true
    },
    DashboardAddon:[
      {
        url: '/progetti/progetti/dashboard/negozio',
        initObj: [{ campo: 'mese', tipo: 'func',force:true, func: (x,api) => {
            x.mese = 3
          } }, { campo: 'anno', tipo: 'func',force:true, func: (x,api) => {
            x.anno = 2026
          } }],
        campi: [
          {
            nome: "Vendite mensili",
            tipo: "lineChart",
            oggetto: "vendite",
            larghezza:'col-12 mt-3',
            linechartOptions: {
              responsive: true,
              lineTension: 0,
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                  },
                },
              },
            }
          },
        ]
      }
    ],
    Cruds: [Dashboard()],
    Menu: [...Dashboard().MenuItems]
  }
  return env;

}
